import { FormControl } from '@angular/forms';
import { ColDef } from 'ag-grid-community';

export interface FilterOption{
  value: number;
  label: string;
  selected: boolean;
}

export interface CustomColDef extends ColDef {
  visible?: boolean;
  disabled?: boolean;
  expanded?: boolean;
  hidden?: boolean;
  customFilters?: string[];
  filterOptions?: FilterOption[];
}

export interface ColDefForm {
  field: FormControl<string>;
  visible: FormControl<boolean>;
}

export interface ColDefFormValue {
  field: string;
  headerName: string;
  visible: boolean;
}

export enum ColDefsNames {
  PRODUCTOS = 'productos',
  CLIENTES = 'clientes',
}

export interface ColumnDefs {
  [name: string]: ColDef[];
}

export interface FilterItem {
  field: string;
  value: string;
  label: string;
  selected: boolean;
  predicate: (value: any) => boolean;
}

export const stockOptions: FilterItem[] = [
  {
    field: 'Existencia',
    value: 'noStock',
    label: 'Sin stock',
    selected: true,
    predicate: (value: any) => value === 0,
  },
  {
    field: 'Existencia',
    value: 'lowStock',
    label: 'Bajo stock',
    selected: true,
    predicate: (value: any) => value > 0 && value <= 10,
  },
  {
    field: 'Existencia',
    value: 'hasStock',
    label: 'Con stock',
    selected: true,
    predicate: (value: any) => value > 10,
  },
];
